import { Component, Input, OnInit } from '@angular/core';
import { FAQSQuestions } from 'src/app/model/question-item';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  @Input() questions:FAQSQuestions [] | undefined = [];
  
  constructor() { }

  ngOnInit(): void {
    console.log(this.questions);
  }

}
